export const environment = {
  production: true,
  myEndpoint: ''
}



// WEBPACK FOOTER //
// /usr/home/rob/Staxi/client/src/environments/environment.ts